<template>
    <div class="validation-errors-modal">
        <div class="validation-errors-content">
            <div
                v-for="(entityGroup, entityType) in groupedErrors"
                :key="entityType"
                class="validation-error-entity"
            >
                <h4 class="entity-header mb-4">
                    {{ translatedDisplayName(entityGroup) }}
                </h4>

                <ul class="error-list">
                    <li v-for="error in entityGroup.errors" :key="error.field" class="error-item">
                        <CoreIcon name="alert-circle-outline" fillColor="var(--color-red-600)" />
                        <span>
                            {{ error.message }}
                        </span>
                    </li>
                </ul>

                <CoreLinkPrimary
                    v-if="entityGroup.navigationInfo && entityGroup.entityId"
                    :to="getNavigationRoute(entityType, entityGroup.entityId)"
                    :text="entityGroup.navigationInfo.displayName"
                    :linkColorBlue="true"
                    iconName="arrow-right"
                    @click="handleModalClose"
                />
            </div>
        </div>

        <footer>
            <CoreButton
                label="§ui_button.close"
                variant="tertiary"
                @click="handleModalClose"
                icon="pi-times"
            />
        </footer>
    </div>
</template>

<script>
import { useModalStore } from '@/stores/modal'
import CoreLinkPrimary from '@/components/core/CoreLinkPrimary.vue'
import CoreIcon from '@/components/core/CoreIcon.vue'
import CoreButton from '@/components/core/CoreButton.vue'

export default {
    name: 'ValidationErrorsModal',

    components: {
        CoreLinkPrimary,
        CoreIcon,
        CoreButton,
    },

    data() {
        return {
            groupedErrors: null,
            entityRouteMap: null,
            modalStore: useModalStore(),
        }
    },

    created() {
        this.groupedErrors = this.modalStore.data.groupedErrors || {}
        this.entityRouteMap = this.modalStore.data.entityRouteMap || {}
    },

    methods: {
        getNavigationRoute(entityType, entityId) {
            const routeConfig = this.entityRouteMap[entityType]

            if (!routeConfig) {
                console.error(`No route configuration for entity type: ${entityType}`)
                return null
            }

            // Get errors for this entity
            const entityGroup = this.groupedErrors[entityType]
            const errors = entityGroup?.errors || []

            const queryParams = {
                validationContext: 'true',
                returnTo: this.$route.fullPath,
            }

            // Include field-level errors in query params
            if (errors.length > 0) {
                queryParams.validationErrors = encodeURIComponent(JSON.stringify(errors))
            }

            return {
                name: routeConfig.route,
                params: {
                    [routeConfig.paramKey]: entityId,
                },
                query: queryParams,
            }
        },

        handleModalClose() {
            this.modalStore.setClose()
        },

        translatedDisplayName(entityGroup) {
            if (entityGroup.navigationInfo?.displayName) {
                return this.$t(entityGroup.navigationInfo.displayName)
            }
            return this.$t('§error.message_data_missing')
        },
    },
}
</script>

<style scoped>
.validation-error-entity {
    margin: 1.5rem 1rem;
    padding: 1rem;
    background-color: var(--color-neutral-medium);
    background-color: var(--color-neutral-300);
    border: 1px solid var(--color-neutral-medium);
    border-radius: 8px;
}

.entity-header {
    font-weight: 300;
}

.error-list {
    list-style-type: none;
    padding-inline-start: 0;
    color: var(--color-neutral-900);
}

.error-item {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    margin-bottom: 0.5rem;

    & > .material-design-icon {
        display: flex;
        align-items: center;
        justify-content: center;
    }
}
</style>
